import { render } from "./PhotoGalleryModal.vue?vue&type=template&id=2d5d61a5&scoped=true"
import script from "./PhotoGalleryModal.vue?vue&type=script&lang=js"
export * from "./PhotoGalleryModal.vue?vue&type=script&lang=js"

import "./PhotoGalleryModal.vue?vue&type=style&index=0&id=2d5d61a5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d5d61a5"]])

export default __exports__